import React from 'react'
import { Link } from 'react-router-dom';
import { useEffect } from 'react';

const NotFound = () => { 
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-white">
  <div className="text-center row">
    <div className=" col-md-6">
      <img src="/assets/page_not_found.png" alt className="img-fluid" />
    </div>
    <div className=" col-md-6 mt-5">
      <p className="fs-3"> <span className="text-danger">Opps!</span> Page not found.</p>
      <p className="lead">
        The page you’re looking for doesn’t exist.
      </p>
      <Link to="/" className="btn btn-primary border-0">Go Home</Link>
    </div>
  </div>
</div>

  )
}

export default NotFound
